import { render, staticRenderFns } from "./NewEnergyPage.vue?vue&type=template&id=95bb6b2e"
import script from "./NewEnergyPage.vue?vue&type=script&lang=js"
export * from "./NewEnergyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports